import React from 'react';

/**
 * Compact results chip — only meaningful after a send attempt:
 * - all succeeded → green "success"
 * - any failures/skips → green "N sent" (if any) plus red "N failed" / "N skipped"
 * - draft / scheduled / not sent → em dash
 */
export default function SuccessFailBadges({ success = 0, failure = 0, skipped = 0, status, compact = false }) {
  const wrapClass = compact ? 'success-fail-badges success-fail-badges--compact' : 'success-fail-badges';
  const ok = Number(success) || 0;
  const fail = Number(failure) || 0;
  const skip = Number(skipped) || 0;
  const showResults = status === 'sent' || status === 'failed' || status === 'sending';

  if (!showResults || (ok === 0 && fail === 0 && skip === 0)) {
    return <span className="value-datetime">—</span>;
  }

  if (fail > 0 || skip > 0) {
    return (
      <span className={wrapClass}>
        {ok > 0 && (
          <span className="count-badge count-badge--success" title="Reached recipients">
            {ok}
            {' '}
            sent
          </span>
        )}
        {fail > 0 && (
          <span className="count-badge count-badge--failure" title="Failed sends">
            {fail}
            {' '}
            failed
          </span>
        )}
        {skip > 0 && (
          <span className="count-badge count-badge--skipped" title="Skipped because contact info is missing">
            {skip}
            {' '}
            skipped
          </span>
        )}
      </span>
    );
  }

  return (
    <span className={wrapClass}>
      <span className="count-badge count-badge--success" title="All sends succeeded">
        success
      </span>
    </span>
  );
}
